import React from 'react'
import SvgIcon from './SvgIcon'

export default SvgIcon(
  <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.51 15.03"><title>SiteIcons</title><path d="M15.63,8.4H.88a.88.88,0,0,1,0-1.76H15.63a.88.88,0,0,1,0,1.76Z"/><path d="M15.63,1.76H.88A.88.88,0,0,1,.88,0H15.63a.88.88,0,0,1,0,1.76Z"/><path d="M15.63,15H.88a.88.88,0,0,1,0-1.76H15.63a.88.88,0,0,1,0,1.76Z"/></svg>
)